<script>
    import { createEventDispatcher } from 'svelte';
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { toast } from "@zerodevx/svelte-toast";
    import * as m from "@app/paraglide/messages.js";
    
    const dispatch = createEventDispatcher();
    let isLocked = $derived(isSelectedEventGroupLocked());
    
    function clearSpeakers() {
        if (isSelectedEventGroupLocked()) {
            toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
            return;
        }

        // Reset speakers array for all selected events
        eventGroupState[projectState.selected].selected.forEach(eventIndex => {
            eventGroupState[projectState.selected].events[eventIndex].speakers = [];
        });
        
        insertHistoryAction({
            name: "clear speaker(s)", //action name
            eventGroup: projectState.selected,
            snapshots: [
            {
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            },
            ],
        });
        
        dispatch('done');
    }
</script>

<button 
    class="dropdown-item" 
    class:disabled={isLocked}
    type="button"
    disabled={isLocked}
    onclick={clearSpeakers}>
    {m.context_menu_clear_speakers()}
</button>
